export default theme => ({
  paper: {
    padding: '1em 2em',
    marginBottom: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.primary.main
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > button': {
      marginRight: 10,
    },
  },
  title: {
    textAlign: 'center',
    border: '1px solid #999',
    borderRadius: 8,
    padding: 5,
    boxSizing: 'border-box',
    boxShadow: 'inset 2px 2px 2px rgba(0, 0, 0, 0.3)',
    width: '100%',
    minHeight: 62,
    fontSize: '2em',
    fontWeight: 500,
    textTransform: 'uppercase',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#4f5eaf',
    backgroundColor: '#dadbe2',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& span': {
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  display: {
    width: '100%',
    overflow: 'hidden',
  },
  time: {
    fontSize: '1.25em',
    padding: '5px 10px',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    opacity: 0.75,
    lineHeight: 1.1,
    letterSpacing: 1,
    marginRight: 10,
  },
  loading: {
    width: '2em',
    height: '2em',
    animation: 'flash 0.5s linear infinite',
  },
  largeIcon: {
    width: '2em',
    height: '2em',
  },
  mediumIcon: {
    width: '1.5em',
    height: '1.5em',
  },
  options: {
    marginLeft: 20,
    display: 'flex',
    '& > svg': {
      color: '#fff',
      width: '1.5em',
      height: '1.5em',
      cursor: 'pointer',
      transition: 'opacity 0.3s',
    }
  },
  '@media(max-width: 850px)': {
    paper: {
      flexDirection: 'column',
    },
    time: {
      display: 'none',
    },
    display: {
      order: 0,
    },
    controls: {
      order: 2,
      marginTop: 20,
      marginBottom: 20,
    },
    options: {
      order: 1,
      marginLeft: 0,
      marginTop: 20,
    }
  }
});